import { faCircleStop } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type React from "react";
import { Button } from "../../../components/Theme/button";

interface RetireAssetButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

export default function RetireAssetButton({
  onClick,
  disabled = false,
}: RetireAssetButtonProps): React.ReactElement {
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      color="red"
      size="sm"
      className="py-1"
    >
      <FontAwesomeIcon icon={faCircleStop} fixedWidth className="mr-1" />
      Retire Asset
    </Button>
  );
}
